import { render, staticRenderFns } from "./ConvoyActionsManagement.vue?vue&type=template&id=385fc0e5&scoped=true"
import script from "./ConvoyActionsManagement.vue?vue&type=script&lang=js"
export * from "./ConvoyActionsManagement.vue?vue&type=script&lang=js"
import style0 from "./ConvoyActionsManagement.vue?vue&type=style&index=0&id=385fc0e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385fc0e5",
  null
  
)

export default component.exports